module.exports = __webpack_public_path__ + "img/logout.9203d6c6.svg";